import OrderServeType from '@/constants/OrderServeType';
import DeliveryType from '@/constants/DeliveryType';
import DeliveryMethodType from '@/constants/DeliveryMethodType';

const isUberDirectPlatform = (webStoreVo, orderVo) => {
  const { deliveryPlatform } = webStoreVo;
  const { serveType } = orderVo;

  if (serveType !== OrderServeType.DELIVERY) return false;
  if (deliveryPlatform !== DeliveryType.UBER_DIRECT) return false;
  return true;
};

const isCustomizeWelcomeUberDirectPlatform = (webStoreVo, serveType) => {
  const { deliveryPlatform } = webStoreVo;

  if (serveType !== OrderServeType.DELIVERY) return false;
  if (deliveryPlatform !== DeliveryType.UBER_DIRECT) return false;
  return true;
};

const getBooleanOfDeliverableAction = (orderVo) => {
  const { deliverableAction } = orderVo;
  if (
    deliverableAction === DeliveryMethodType.deliverable_action_meet_at_door
  ) {
    return true;
  }
  if (
    deliverableAction === DeliveryMethodType.deliverable_action_leave_at_door
  ) {
    return false;
  }
  return null;
};

const getStringOfUberDeliverableAction = (deliveryMethod) => {
  if (deliveryMethod) {
    return DeliveryMethodType.deliverable_action_meet_at_door;
  }
  return DeliveryMethodType.deliverable_action_leave_at_door;
};

const UberDirectStatus = {
  isUberDirectPlatform,
  getBooleanOfDeliverableAction,
  getStringOfUberDeliverableAction,
  isCustomizeWelcomeUberDirectPlatform,
};
export default UberDirectStatus;
